import React from 'react';
import {
  Box,
  Button,
  Flex,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
} from '@chakra-ui/react';
import {IntentGroupLabels, useIntentModelStore} from './IntentModeStore';
import {IntentSignalGroup} from './IntentSignalGroup';
import {entries} from '../../shared/util';
import {ChevronDown} from '@carbon/icons-react';
import {useIntentGroups} from './useIntentGroups';
import {useIntentGroupOptions} from './useIntentGroupOptions';

export const IntentSignals = () => {
  const {addPlaceholderField} = useIntentModelStore();
  const intentGroups = useIntentGroups();
  const intentGroupOptions = useIntentGroupOptions();

  const addableGroups = entries(intentGroupOptions).filter(
    ([group, options]) =>
      // There is not an existing signal group
      !intentGroups.some(({group: existingGroup}) => existingGroup === group) &&
      // And, there are options available to select
      options.length > 0
  );

  return (
    <Flex
      bgColor="white"
      border="1px"
      borderColor="kgray.200"
      borderRadius="lg"
      direction="column"
      gap="6"
      h="fit-content"
      p="6"
      w="100%"
    >
      <Flex direction="column" gap="2">
        <Box fontSize="xl">Select Signals</Box>
        <Box fontSize="sm" textColor="kgray.300">
          Add signals to your intent score from your connected sources.
        </Box>
      </Flex>

      {intentGroups.map(({group, fields}) => (
        <IntentSignalGroup key={group} group={group} fields={fields} />
      ))}

      <Menu>
        <MenuButton
          as={Button}
          colorScheme="kbuttonblue"
          isDisabled={!addableGroups.length}
          rightIcon={<ChevronDown />}
          variant="outline"
          w="fit-content"
        >
          Add Source Group
        </MenuButton>
        <MenuList>
          {addableGroups.map(([group]) => (
            <MenuItem key={group} onClick={() => addPlaceholderField(group)}>
              {IntentGroupLabels[group]}
            </MenuItem>
          ))}
        </MenuList>
      </Menu>
    </Flex>
  );
};
